"use client";

import React from "react";
import Link from "next/link";
import { NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { getStoryblokLinkProps } from "@/lib/storyblok/get-storyblok-link-props";
import { NavItemStoryblok } from "@/types/sb-component-types";
import { resolveSbLink } from "@/lib/storyblok/resolve-sb-link";
import { useCurrentLocale } from "@/locales/client";
interface NavItemProps {
  navItem: NavItemStoryblok;
  isTransparent: boolean;
}
export const NavItem = ({
  navItem,
  isTransparent
}: NavItemProps) => {
  const locale = useCurrentLocale();
  const linkStyles = isTransparent ? "text-white hover:text-white/80 bg-transparent hover:bg-background/10" : "text-foreground hover:text-foreground/80";
  return <NavigationMenuItem data-sentry-element="NavigationMenuItem" data-sentry-component="NavItem" data-sentry-source-file="NavItem.tsx">
      {navItem.sub_nav_items?.length ? <>
          <Link legacyBehavior passHref href={resolveSbLink(navItem.link, locale)}>
            <NavigationMenuTrigger className={linkStyles}>
              {navItem.title}
            </NavigationMenuTrigger>
          </Link>
          <NavigationMenuContent>
            <ul className="flex w-56 flex-col gap-3 p-4">
              {navItem.sub_nav_items.map((subNavItem, subIndex) => <li key={subIndex}>
                  <Link {...getStoryblokLinkProps(subNavItem.link)} legacyBehavior passHref>
                    <NavigationMenuLink className="block select-none space-y-1 rounded-sm p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground">
                      {subNavItem.title}
                    </NavigationMenuLink>
                  </Link>
                </li>)}
            </ul>
          </NavigationMenuContent>
        </> : <Link legacyBehavior passHref href={resolveSbLink(navItem.link, locale)}>
          <NavigationMenuLink className={`${navigationMenuTriggerStyle()} ${linkStyles}`}>
            {navItem.title}
          </NavigationMenuLink>
        </Link>}
    </NavigationMenuItem>;
};